<template>
  <div class="schedule schedule--date background-gray min-height-inherit">
    <section class="py-4 py-md-5">
      <div class="container container--md">
        <div class="mb-3 d-none d-lg-block">
          <schedule-breadcrumb />
        </div>
        <ValidationObserver
          ref="observer"
          v-slot="{}"
          tag="form"
          @submit.prevent="handleSubmit"
        >
          <div class="schedule-details box box-sm-none">
            <div class="schedule-details__header">
              <h3 class="title title--main mb-2 mb-lg-0 mr-lg-4">
                Buscar por:
              </h3>
              <div class="schedule-details__menu">
                <router-link
                  :to="{
                    name: 'schedule-date',
                    service: current_schedule.service_slug,
                  }"
                  class="schedule-details__nav button button--secondary"
                >
                  <span class="button__text">Horario</span>
                </router-link>
                <router-link
                  :to="{
                    name: 'schedule-specialist',
                    service: current_schedule.service_slug,
                  }"
                  class="schedule-details__nav button button--default"
                >
                  <span class="button__text">Asesor de servicio</span>
                </router-link>
              </div>
            </div>
            <div>
              <p class="title title--s text-primary weight-bold mb-3">
                Selecciona el día:
              </p>
              <div class="row">
                <div class="col-md-6">
                  <ValidationProvider
                    name="día"
                    vid="date"
                    rules="required"
                    v-slot="{ classes, errors }"
                    tag="div"
                  >
                    <datepicker
                      :class="[classes, 'datepicker']"
                      id="date"
                      v-model="data.day"
                      maximum-view="day"
                      :full-month-name="true"
                      :inline="true"
                      :language="calendar_language"
                      :disabled-dates="calendar_disabled"
                      :monday-first="true"
                      :use-utc="false"
                      @input="onSetDate"
                      @changedMonth="handleGetAvailableDates"
                    />
                    <span class="form-helper form-helper--error mt-1">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
                <div class="col-md-6 mt-3 mt-lg-0">
                  <ValidationProvider
                    name="horario"
                    vid="hour"
                    rules="required"
                    v-slot="{ classes, errors }"
                    tag="div"
                  >
                    <div :class="[classes, 'timepicker box']">
                      <div class="timepicker__header text-primary">
                        <i class="material-icons">schedule</i>
                        <h4 class="title title--xs weight-bold">
                          {{
                            hours.length
                              ? `Tenemos ${hours.length} horarios disponibles`
                              : 'Horarios disponibles'
                          }}
                        </h4>
                      </div>
                      <div class="timepicker__content">
                        <!-- <p class="text text-light weight-bold mb-3">
                          Nuestro horario de atención es de lunes a viernes de
                          09:00 a 18:30.
                        </p> -->
                        <div
                          class="timepicker__hours scroll"
                          v-if="hours.length"
                        >
                          <div class="scroll__content">
                            <div
                              class="mb-2 last transition"
                              v-for="hour in hours"
                              :key="hour.id"
                              @click="onSetHour(hour)"
                            >
                              <card-hour
                                :class="{
                                  'card-hour--disabled': hour.disabled,
                                  'card-hour--selected':
                                    !hour.disabled && hour.id === data.hour.id,
                                }"
                                :data="hour"
                                v-model="data.hour"
                              ></card-hour>
                            </div>
                          </div>
                          <div class="scroll__shadow"></div>
                        </div>
                        <div
                          v-else
                          class="text text-primary text-center weight-bold"
                        >
                          <i class="material-icons">schedule</i>
                          <p>
                            Selecciona un día para revisar los horarios
                            disponibles
                          </p>
                        </div>
                      </div>
                    </div>
                    <span class="form-helper form-helper--error mt-1">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
          </div>
          <div class="text-center mt-4">
            <button class="button button--secondary" type="submit">
              <span class="button__text">Confirmar hora</span>
            </button>
          </div>
        </ValidationObserver>
      </div>
    </section>
  </div>
</template>

<script>
import { getAvailableDates, getAvailableHours } from '@/services/dates';

import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { es } from 'vuejs-datepicker/dist/locale';

import ScheduleBreadcrumb from '@/components/ScheduleBreadcrumb.vue';
import CardHour from '@/components/CardHour.vue';

import { mapState } from 'vuex';

export default {
  name: 'ScheduleDate',
  components: {
    Datepicker,
    ScheduleBreadcrumb,
    CardHour,
  },
  data() {
    return {
      calendar_language: es,
      calendar_disabled: {
        // to: new Date(),
        customPredictor: date => {
          const newDate = moment(date);
          return !this.days.includes(this.dateFormat(newDate));
        },
      },
      data: {
        day: '',
        hour: '',
      },
      days: [],
      hours: [],
      loading: false,
    };
  },
  mounted() {
    this.$store.commit('set_title', 'Estás agendando');
    this.$store.dispatch('setCurrentStep', 3);

    this.executeDataLayer();

    if (this.current_schedule.date) {
      this.data.day = this.current_schedule.date.day;
      this.data.hour = this.current_schedule.date.hour
        ? this.current_schedule.date.hour
        : '';
      this.handleGetAvailableDates(this.data.day);
      this.onSetDate();
      return;
    }

    this.handleGetAvailableDates();
  },
  computed: {
    ...mapState(['current_schedule']),
  },
  methods: {
    executeDataLayer: async function() {
      if (!window.dataLayer) {
        return;
      }

      const eventData = {
        event: 'agendamiento-paso',
        paso: 3,
      };

      console.log('Sent to dataLayer', eventData);

      window.dataLayer.push(eventData);
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.submitForm();
    },
    submitForm() {
      this.loading = true;

      this.$store
        .dispatch('setSelectedDate', this.data)
        .then(() => this.$router.push({ name: 'schedule-summary' }))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido registrar la hora seleccionada',
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    handleGetAvailableDates($event) {
      const current_date = $event || new Date();
      const from_date = moment(current_date).startOf('month');
      const to_date = moment(current_date).endOf('month');

      this.getAvailableDatesFromApi(
        this.dateFormat(from_date),
        this.dateFormat(to_date),
      )
        .then(days => (this.days = days))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener las fechas',
          });
        });
    },
    onSetDate() {
      this.data.hour = '';
      this.getAvailableHoursFromApi(this.dateFormat(this.data.day))
        .then(hours => (this.hours = hours))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener los horarios',
          });
        });
    },
    onSetHour(data) {
      this.data.hour = data;
    },
    dateFormat(date) {
      return moment(date).format('Y-MM-DD');
    },
    async getAvailableDatesFromApi(from, to) {
      const response = await getAvailableDates(from, to);
      return response.data.data;
    },
    async getAvailableHoursFromApi(date) {
      const response = await getAvailableHours(date);
      return response.data.data;
    },
  },
};
</script>
